// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oBo9","newExpiryDate":"styles_newExpiryDate__3fsAw","footer":"styles_footer__108wq"};